export const loggedIn = () => !!localStorage.token;

export const getToken = () => localStorage.token;

export const setToken = token => localStorage.token = token;
export const deleteToken = () => localStorage.removeItem('token');



// WEBPACK FOOTER //
// ./src/auth.js